<div class="view-client page">
  @if (!isLoading) {
    <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
    <div class="heading-wrapper">
      <div class="heading-left">
        <h4>{{ client?.fullName }}{{ client?.officialDocumentId ? ', ' + client?.officialDocumentId : '' }}</h4>
        <p class="client-status" [ngClass]="[client?.status]">
          {{ 'pages.client.FrontofficeReadingRoomSubmissionStatus.' + client?.status | translate }}
        </p>
      </div>
      @if (client?.clientType !== 'Organization') {
        <button class="primary" [disabled]="client?.status === 'Deleted'" (click)="navigateToInfoRequest()" type="button">
          {{ 'pages.client.addInfoRequest' | translate }}
        </button>
      }
    </div>
    <div class="content-wrapper">
      <app-content-side-nav
        [navItems]="navItems"
        [navItemsCounts]="{ notes: notesCount }"
        [activeItem]="initialActiveItem"
        [shouldTranslate]="true"
        [changeBack]="changeBack"
        (itemSelected)="onSectionChanged($event, !hasFormChanged)" />
      @if (!isLoading && client) {
        <div class="active-form">
          @if (activeItem === 'general') {
            <app-general-info-form
              [client]="client"
              [countries]="countries"
              (clientUpdated)="onClientUpdated($event)"
              (formChanged)="hasFormChanged = $event" />
          } @else if (activeItem === 'readers_card') {
            <app-readers-card-form
              [client]="client"
              [readersCard]="readersCard"
              [researchTopics]="researchTopics"
              (readersCardUpdated)="getReadersCard()"
              (refetchTopics)="getResearchTopics()"
              (formChanged)="hasFormChanged = $event" />
          } @else if (activeItem === 'service_history') {
            <app-table
              [endpoint]="clientApplicationsEndpoint"
              [withSearch]="false"
              [withPagination]="true"
              [clientId]="clientId || null"
              [columns]="appTableColumns"
              [getViewPathFn]="getServiceRequestViewPath"
              [draftsFirstKey]="'submittedOn'"
              responseKey="page"
              sortBy="SubmittedOn"
              sortDirection="desc" />
          } @else if (activeItem === 'activities') {
            <app-client-activities [client]="client" (clientDelete)="deleteClient($event)" />
          } @else if (activeItem === 'notifications') {
            <app-client-notifications [clientId]="client.id!" />
          } @else if (activeItem === 'notes') {
            <app-lna-notes-form
              [client]="client"
              [notes]="clientNotes!"
              [isSubmittingNoteFiles]="isSubmittingNoteFiles"
              (pageChange)="onNotesPageChange($event)"
              (formChanged)="hasFormChanged = $event" />
          }
        </div>
      }
    </div>
  } @else {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="isLoading" />
    </div>
  }
</div>

<app-confirm-modal
  [isOpen]="confirmModalOpen"
  (cancel)="confirmModalOpen = false"
  (confirm)="onSectionChanged(nextSection, true)"
  title="unsavedChanges"
  bodyText="unsavedChangesBody"
  confirmText="continue"
  denyText="cancelBack" />
